<p>sed-events-summary works!</p>
